module.exports = __webpack_public_path__ + "static/Lotus-01-c572223c1ffd37502f870d4c8d2852cb.png";